/**
 * Advisor (agent) status values (T20-3323).
 *
 * The vocabulary is owned upstream by CRM and reaches the app through the
 * Snowflake agent dimension. These are the seven values observed in the source.
 * An unrecognized value is still rendered verbatim rather than hidden, so a new
 * status upstream degrades gracefully instead of disappearing from the UI.
 */
export const ADVISOR_STATUS_VALUES = [
  'Active',
  'Onboarding',
  'MIA',
  'Industry Inactive',
  'Terminated',
  'Transferred',
  'Back Office',
] as const;

/**
 * Sentinel for policies whose advisor carries no status upstream. The API maps
 * it to `agent_status IS NULL`; it is not a real CRM status.
 */
export const ADVISOR_STATUS_UNKNOWN = 'unknown';

const UNKNOWN_LABEL = 'Unknown';

/** Options for the advisor-status filter dropdown, in display order. */
export const ADVISOR_STATUS_FILTER_OPTIONS: { value: string; label: string }[] = [
  ...ADVISOR_STATUS_VALUES.map((value) => ({ value, label: value })),
  { value: ADVISOR_STATUS_UNKNOWN, label: UNKNOWN_LABEL },
];

const ADVISOR_STATUS_FILTER_VALUES = new Set<string>(
  ADVISOR_STATUS_FILTER_OPTIONS.map((opt) => opt.value)
);

/** Is the value a supported advisor-status filter value (not a sentinel/garbage)? */
export function isAdvisorStatusFilterValue(value: string | null | undefined): value is string {
  return !!value && ADVISOR_STATUS_FILTER_VALUES.has(value);
}

/** Label for the filter chip and dropdown. */
export function formatAdvisorStatus(value: string): string {
  return value === ADVISOR_STATUS_UNKNOWN ? UNKNOWN_LABEL : value;
}
